// extracted by mini-css-extract-plugin
module.exports = {"s13dct2e":"s13dct2e"};